module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e103deb85b6f54309b24892f06817666.png";